import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export default function ShopDetailPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState(1); // 1=services, 2=datetime, 3=confirm
  const [selected, setSelected] = useState({ service: null, staff: null, date: '', time: '' });
  
  // Auto-fill today's date (Pakistan time)
  useEffect(() => {
    axios.get('/api/shop/reports/today').then(r => {
      setSelected(s => ({...s, date: r.data.today}));
      loadSlots(r.data.today, null);
    }).catch(() => {
      const now = new Date();
      const pk = new Date(now.getTime() + 5*60*60*1000 + now.getTimezoneOffset()*60*1000);
      const today = pk.toISOString().split('T')[0];
      setSelected(s => ({...s, date: today}));
      loadSlots(today, null);
    });
  }, []);
  const [slots, setSlots] = useState([]);
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');

  useEffect(() => {
    axios.get(`/api/public/shops/${slug}`).then(r => { setData(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  const loadSlots = async (date, staffId) => {
    setSlotsLoading(true);
    try {
      const params = { date };
      if (staffId && staffId !== 'any') params.staff_id = staffId;
      const r = await axios.get(`/api/public/shops/${slug}/slots`, { params });
      setSlots(r.data.slots || []);
      if (!r.data.available) toast.error(r.data.message || 'Shop is din band hai');
    } catch { setSlots([]); }
    setSlotsLoading(false);
  };

  const handleDateChange = (date) => {
    setSelected(s => ({...s, date, time: ''}));
    if (date) loadSlots(date, selected.staff?.id);
  };

  const handleWhatsApp = async () => {
    if (!customerName.trim()) return toast.error('Apna naam enter karein');
    if (!customerPhone.trim()) return toast.error('Apna WhatsApp number enter karein');
    if (!selected.date || !selected.time) return toast.error('Date aur time select karein');
    try {
      const r = await axios.post(`/api/public/shops/${slug}/whatsapp`, {
        customer_name: customerName,
        customer_phone: customerPhone,
        service_id: selected.service?.id,
        date: selected.date,
        time: selected.time,
        staff_id: selected.staff?.id || null
      });
      window.open(r.data.waLink, '_blank');
    } catch { toast.error('Error. Dobara try karein.'); }
  };

  const maxDate = () => {
    const d = new Date();
    d.setDate(d.getDate() + (data?.shop?.advance_booking_days || 7));
    return d.toISOString().split('T')[0];
  };

  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--primary)' }}><div className="spinner" /></div>;
  if (!data) return <div style={{ textAlign: 'center', padding: '80px' }}><h2>Shop nahi mili</h2><a href="/shops" className="btn btn-primary mt-4">← Wapas jayen</a></div>;

  const { shop, services, staff, workingHours, reviews, gallery } = data;

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      {/* Header */}
      <div style={{ background: 'var(--primary)', color: 'white', padding: '20px 0' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 20px' }}>
          <a href="/shops" style={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', fontSize: '14px' }}>← Wapas</a>
        </div>
      </div>

      {/* Shop Hero with Cover Image */}
      {shop.cover_image_url && (
        <div style={{
          width: '100%', maxHeight: '380px', overflow: 'hidden', background: '#000'
        }}>
          <img src={`https://barber.brainbox19.com${shop.cover_image_url}`} alt={shop.shop_name} style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'contain', maxHeight: '380px', margin: '0 auto' }} />
        </div>
      )}
      <div style={{
        background: 'var(--primary)', color: 'white', paddingBottom: '40px', position: 'relative'
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '20px 20px 0' }}>
          <div className="flex gap-3" style={{ flexWrap: 'wrap' }}>
            <div style={{ width: '80px', height: '80px', borderRadius: '16px', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '36px', flexShrink: 0, boxShadow: '0 8px 24px rgba(0,0,0,0.3)', overflow: 'hidden' }}>{shop.logo_url ? <img src={`https://barber.brainbox19.com${shop.logo_url}`} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (shop.shop_type === 'parlour' ? '💄' : shop.shop_type === 'dentist' ? '🦷' : '✂️')}</div>
            <div style={{ flex: 1 }}>
              <h1 style={{ fontFamily: 'Syne', fontSize: 'clamp(22px, 5vw, 32px)', textShadow: '0 2px 12px rgba(0,0,0,0.5)', wordBreak: 'break-word' }}>{shop.shop_name}</h1>
              <p style={{ color: 'rgba(255,255,255,0.8)', marginTop: '4px', textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}>📍 {shop.city}{shop.address ? `, ${shop.address}` : ''}</p>
              {shop.description && <p style={{ color: 'rgba(255,255,255,0.9)', marginTop: '8px', fontSize: '14px', maxWidth: '600px', textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}>{shop.description}</p>}
              <div style={{ marginTop: '16px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button className="btn btn-sm" style={{ background: 'rgba(255,255,255,0.15)', color: 'white', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.3)' }}
                  onClick={() => {
                    if (navigator.share) {
                      navigator.share({ title: shop.shop_name, text: `${shop.shop_name} pe online booking karein!`, url: window.location.href });
                    } else {
                      navigator.clipboard.writeText(window.location.href);
                      alert('Link copy ho gaya! Apne contacts ko bhejein.');
                    }
                  }}>📤 Share Shop</button>
                <button className="btn btn-sm" style={{ background: '#25D366', color: 'white' }}
                  onClick={() => {
                    const msg = `✂️ *${shop.shop_name}*\n📍 ${shop.city}\n\nOnline booking karein:\n${window.location.href}\n\nSave kar lein — agla baar seedha yahan se booking ho gi! 📱`;
                    window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
                  }}>📲 WhatsApp Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '32px 20px' }}>
        <div className="grid-2" style={{ gap: '28px', alignItems: 'start' }}>
          {/* Left - Shop Info */}
          <div>
            {/* Services */}
            <div className="card mb-4">
              <h3 style={{ marginBottom: '16px' }}>{shop.shop_type === 'parlour' ? '💅' : shop.shop_type === 'dentist' ? '🦷' : '✂️'} Services & Prices</h3>
              {services.map(s => (
                <div key={s.id} onClick={() => { setSelected(sel => ({...sel, service: s})); setStep(2); }}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px', borderRadius: '8px', cursor: 'pointer', background: selected.service?.id === s.id ? 'rgba(233,69,96,0.08)' : 'transparent', border: selected.service?.id === s.id ? '2px solid var(--accent)' : '2px solid transparent', marginBottom: '8px', transition: 'all 0.15s' }}>
                  <div>
                    <div style={{ fontWeight: 600 }}>{s.name}</div>
                    {s.description && <div style={{ fontSize: '12px', color: 'var(--text-light)' }}>{s.description}</div>}
                    <div style={{ fontSize: '12px', color: 'var(--text-light)', marginTop: '2px' }}>⏱ {s.duration_minutes} min</div>
                  </div>
                  <div style={{ fontWeight: 700, fontSize: '18px', color: 'var(--success)', whiteSpace: 'nowrap' }}>PKR {Number(s.price).toLocaleString()}</div>
                </div>
              ))}
            </div>

            {/* Working Hours */}
            <div className="card mb-4">
              <h3 style={{ marginBottom: '16px' }}>🕐 Working Hours</h3>
              {workingHours.map(h => (
                <div key={h.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: '14px' }}>
                  <span style={{ fontWeight: 500 }}>{DAYS[h.day_of_week]}</span>
                  {h.is_closed ? <span style={{ color: 'var(--danger)' }}>Band</span> : <span style={{ color: 'var(--success)' }}>{h.open_time?.slice(0,5)} — {h.close_time?.slice(0,5)}</span>}
                </div>
              ))}
            </div>

            {/* Staff */}
            {staff.length > 0 && (
              <div className="card mb-4">
                <h3 style={{ marginBottom: '16px' }}>{shop.shop_type === 'parlour' ? '💄 Our Staff' : shop.shop_type === 'dentist' ? '🦷 Our Doctors' : '💈 Our Barbers'}</h3>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  {staff.map(s => (
                    <div key={s.id} onClick={() => { const newStaff = selected.staff?.id === s.id ? null : s; setSelected(sel => ({...sel, staff: newStaff, time: ''})); if (selected.date) loadSlots(selected.date, newStaff?.id); }}
                      style={{ textAlign: 'center', padding: '12px', borderRadius: '10px', cursor: 'pointer', border: selected.staff?.id === s.id ? '2px solid var(--accent)' : '2px solid var(--border)', minWidth: '90px', transition: 'all 0.15s' }}>
                      <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 6px', color: 'white', fontWeight: 700 }}>{s.name.charAt(0)}</div>
                      <div style={{ fontSize: '13px', fontWeight: 600 }}>{s.name}</div>
                      <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>{s.role}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Reviews */}
            {reviews.length > 0 && (
              <div className="card">
                <h3 style={{ marginBottom: '16px' }}>⭐ Customer Reviews</h3>
                {reviews.map((r, i) => (
                  <div key={i} style={{ padding: '12px 0', borderBottom: '1px solid var(--border)' }}>
                    <div className="flex-between mb-3">
                      <strong>{r.customer_name}</strong>
                      <span style={{ color: 'var(--gold)', fontSize: '14px' }}>{'⭐'.repeat(r.rating)}</span>
                    </div>
                    {r.comment && <p style={{ fontSize: '14px', color: 'var(--text-light)' }}>{r.comment}</p>}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Right - Booking Widget */}
          <div className="card" style={{ position: 'sticky', top: '20px', borderTop: '4px solid var(--accent)' }}>
            <h3 style={{ marginBottom: '20px', color: 'var(--primary)' }}>📅 Booking Karein</h3>

            {/* Selected Service */}
            {selected.service && (
              <div style={{ background: 'rgba(233,69,96,0.06)', borderRadius: '8px', padding: '12px', marginBottom: '16px' }}>
                <div className="flex-between">
                  <div><div style={{ fontWeight: 600 }}>{selected.service.name}</div><div style={{ fontSize: '12px', color: 'var(--text-light)' }}>⏱ {selected.service.duration_minutes} min</div></div>
                  <div style={{ fontWeight: 700, color: 'var(--accent)' }}>PKR {Number(selected.service.price).toLocaleString()}</div>
                </div>
              </div>
            )}

            <div className="form-group">
              <label className="form-label">📅 Date Select Karein *</label>
              <input type="date" className="form-control" min={new Date().toISOString().split('T')[0]} max={maxDate()} value={selected.date} onChange={e => handleDateChange(e.target.value)} />
            </div>

            {selected.date && (
              <div className="form-group">
                <label className="form-label">⏰ Time Slot Select Karein *</label>
                {slotsLoading ? <div style={{ textAlign: 'center', padding: '20px' }}><div className="spinner" style={{ margin: '0 auto', width: '28px', height: '28px' }} /></div> : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                    {slots.map((slot, i) => (
                      <button key={i} disabled={slot.isBooked} onClick={() => setSelected(s => ({...s, time: slot.time}))}
                        style={{ padding: '8px', border: `2px solid ${slot.isBooked ? '#eee' : selected.time === slot.time ? 'var(--accent)' : 'var(--border)'}`, borderRadius: '8px', background: slot.isBooked ? '#f5f5f5' : selected.time === slot.time ? 'var(--accent)' : 'white', color: slot.isBooked ? '#ccc' : selected.time === slot.time ? 'white' : 'var(--text)', fontSize: '13px', cursor: slot.isBooked ? 'not-allowed' : 'pointer', transition: 'all 0.15s' }}>
                        {slot.isBooked ? '🔒' : slot.time}
                      </button>
                    ))}
                    {slots.length === 0 && <p style={{ gridColumn: '1/-1', textAlign: 'center', color: '#999', fontSize: '13px' }}>Is din koi slot available nahi</p>}
                  </div>
                )}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">👤 Aapka Naam *</label>
              <input className="form-control" placeholder="Apna naam likhein" value={customerName} onChange={e => setCustomerName(e.target.value)} />
            </div>

            <div className="form-group">
              <label className="form-label">📱 WhatsApp Number *</label>
              <input className="form-control" placeholder="923XXXXXXXXX" value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} />
              <small style={{ fontSize: '11px', color: 'var(--text-light)' }}>Confirmation message yahan aayega</small>
            </div>

            <button className="btn btn-whatsapp btn-full btn-lg" onClick={handleWhatsApp} style={{ fontSize: '15px', fontWeight: 700 }}>
              📲 WhatsApp pe Book Karein
            </button>
            <p style={{ fontSize: '12px', color: 'var(--text-light)', textAlign: 'center', marginTop: '10px' }}>
              WhatsApp open hoga — shop ko message jayega — woh confirm karega ✅
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
